import React from 'react';
import classNameBind from 'classnames/bind';
import { useTranslation } from '../Translator';

import Text from '../Text';
import { TextField } from '../TextField';
import styles from './MenuSidebar.module.css';
import { MenuSidebarElement } from './components/MenuSidebarElement';
import { LabelElement } from './components/LabelElement';

const bindClasses = classNameBind.bind(styles);

const MenuSidebar = ({
  routerLink,
  routerMode = 'legacy',
  listData,
  withAccordion = false,
  accordionOnClick = () => {},
  withSearch = false,
  search = '',
  onSearchChange = () => {},
}) => {
  const { t } = useTranslation('components');

  return (
    <div
      className={bindClasses('container')}
      data-ppuc-id="MenuSidebar"
    >
      {withSearch && (
        <>
          <TextField
            name="search"
            icon="search"
            value={search}
            onChange={onSearchChange}
            clearable
            autoFocus
            dataId="MenuSidebar.search"
          />
          <div className={bindClasses('search-divider')} />
        </>
      )}
      {listData.length > 0
        ? listData.map((section, sectionIndex) => (
          <div
            className={bindClasses('section')}
            key={sectionIndex}
          >
            <div className={bindClasses('section-label-wrapper')}>
              {section.section && (
                <LabelElement section={section} withAccordion={withAccordion} accordionOnClick={accordionOnClick} />
              )}
            </div>
            {!section.accordionClosed && section.links.map((link, linkIndex) => (
              <MenuSidebarElement
                data={link}
                RouterLink={routerLink}
                routerMode={routerMode}
                key={linkIndex}
              />
            ))}
          </div>
        ))
        : (
          <div className={bindClasses('no-results-wrapper')}>
            <Text type="subdued">{t('noResults')}</Text>
          </div>
        )}
    </div>
  );
};

export { MenuSidebar };
